import { __decorate } from "tslib";
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { sharedStyles } from '../../common/css/shared-styles';
import { USBrandCampaign } from '../../common/us-branding';
let CampaignSectionRelationships = class CampaignSectionRelationships extends USBrandCampaign {
    render() {
        return html `
    <div class="component">
      <div class="inner">
    <h2>Un ampio spettro di capacità d’investimento</h2>
    <p>Accedi a una rete selezionata di gestori di investimenti specializzati nei mercati pubblici e privati, attraverso un’unica partnership solida e affidabile.<br />Ogni gestore opera con piena autonomia e porta con sé una cultura aziendale distintiva, offrendo un’ampia gamma di strategie e strumenti d’investimento. Il nostro obiettivo è supportarti nell’allocazione efficiente del capitale e nella creazione di soluzioni su misura, grazie a un approccio basato su approfondimenti strategici, consulenza dedicata e servizi di alto livello.</p>
    <div class="logos">
      <div class="logo_items">
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/benefit-street-partners" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="Benefit Street Partners">
            <img src="./assets/images/Benefit-Street-Partners.svg" alt="Benefit Street Partners logo">
          </a>
        </div>
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/brandywine-global" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="BrandywineGLOBAL">
            <img src="./assets/images/Brandywine-Global-Logo.svg" alt="BrandywineGLOBAL logo">
          </a>
        </div>
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/clarion-partners" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="Clarion Partners">
            <img src="./assets/images/clarion-partners-dynamicCards.svg" alt="Clarion Partners logo">
          </a>
        </div>
        <div>
          <a href="hhttps://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/clearbridge" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="ClearBridge">
            <img src="./assets/images/clearbridge-only-logo.svg" alt="ClearBridge logo">
          </a>
        </div>
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/conosciamo-i-gestori-dinvestimento-di-franklin-templeton" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="Franklin Templeton">
            <img src="./assets/images/franklin-templeton.png" alt="Franklin Templeton logo" style="height: auto; margin-top: 35px;">
          </a>
        </div>
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/lexington-partners" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="Lexington Partners">
            <img src="./assets/images/lexington-partners-logo-new.svg" alt="Lexington Partners logo">
          </a>
        </div>
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/putnam-investments" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="Putnam Investments">
            <img src="./assets/images/putnam-logo-us-hp.svg" alt="Putnam Investments logo">
          </a>
        </div>
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/royce" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="Royce">
            <img src="./assets/images/royce.svg" alt="Royce logo">
          </a>
        </div>
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/western-asset" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="Western Asset">
            <img src="./assets/images/western-asset.svg" alt="Western Asset logo"></a>
        </div>
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/benefit-street-partners" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="Benefit Street Partners">
            <img src="./assets/images/Benefit-Street-Partners.svg" alt="Benefit Street Partners logo">
          </a>
        </div>
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/brandywine-global" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="BrandywineGLOBAL">
            <img src="./assets/images/Brandywine-Global-Logo.svg" alt="BrandywineGLOBAL logo">
          </a>
        </div>
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/clarion-partners" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="Clarion Partners">
            <img src="./assets/images/clarion-partners-dynamicCards.svg" alt="Clarion Partners logo">
          </a>
        </div>
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/clearbridge" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="ClearBridge">
            <img src="./assets/images/clearbridge-only-logo.svg" alt="ClearBridge logo">
          </a>
        </div>
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/conosciamo-i-gestori-dinvestimento-di-franklin-templeton" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="Franklin Templeton">
            <img src="./assets/images/franklin-templeton.png" alt="Franklin Templeton logo" style="height: auto; margin-top: 35px;">
          </a>
        </div>
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/lexington-partners" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="Lexington Partners">
            <img src="./assets/images/lexington-partners-logo-new.svg" alt="Lexington Partners logo">
          </a>
        </div>
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/putnam-investments" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="Putnam Investments">
            <img src="./assets/images/putnam-logo-us-hp.svg" alt="Putnam Investments logo">
          </a>
        </div>
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/royce" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="Royce">
            <img src="./assets/images/royce.svg" alt="Royce logo">
          </a>
        </div>
        <div>
          <a href="https://www.franklintempleton.it/chi-siamo/gestori-di-investimenti-specializzati/western-asset" target="_blank" @click="${this.trackCarouselClick}" data-carousel-title="Western Asset">
            <img src="./assets/images/western-asset.svg" alt="Western Asset logo"></a>
        </div>        
      </div>
    </div>

    <div class="container">
  <div class="card1">
    <div class="card">
        <h3>Una gamma completa di fondi comuni di investimento</h3>
        <p></p>
        <a href="https://www.franklintempleton.it/prodotti/nav-e-rendimenti" @click="${this.trackLink}">Scopri i nostri fondi</a>
    </div>
  </div>
  <div class="card2">
  <div class="card">
        <h3>30+ ETF in tutte le asset class</h3>
        <p></p>
        <a href="https://www.franklintempleton.it/prodotti/i-nostri-etf" @click="${this.trackLink}">Scopri i nostri ETF</a>
    </div>
  </div>
</div>
  </div>
  </div>
        <slot></slot>`;
    }
};
CampaignSectionRelationships.styles = [
    sharedStyles,
    css `
    :host {
        display: flex;
        width: 100%;
        margin: 0 auto;
        background: #fff;
        padding: 0;
        position: relative;
        z-index: 4;
        /*min-height: 100vh;*/
        align-content: center;
        flex-wrap: wrap;        
    }

    .card {
      margin-bottom: 2rem;
    }

    .inner {
      padding: 0;
    } 

    .grid {  
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: 1fr;
      gap: 3rem 4.55rem;
      /*gap: 2rem 3rem;*/
      grid-auto-flow: row;
    }
    
    .left-col {
      justify-self: start;
      align-self: start;
      grid-area: 1 / 1 / 2 / 2;
      width: 100%;
    }
    
    .mid-col {
        justify-self: end;
        align-self: start;        
        grid-area: 1 / 2 / 2 / 3;
        width: 100%;
      }

    .right-col {
      justify-self: end;
      align-self: start;
      grid-area: 1 / 3 / 2 / 4;
      width: 100%;
    }

    h2, p {
        color: var(--ft-black);
      }

    .card {
      background: #fff;
      padding: 2rem;
      border-radius: 12px;
      border: 1px solid #ccc;

      & p {
        color: var(--ft-black);
      }

      & h3 {
        color: rgba(0,30,98,1);
        font-family: var(--font-bold);
      }
    }

    img {
      max-width: 200px;
    }

    a {
      display: block;
      color: var(--ft-sky-blue);      
    }    

    @media (min-width: 768px) {
    .container {  display: grid;
        grid-template-columns: repeat(2, 1fr);
 /*       grid-template-rows: repeat(2, 1fr);*/
        gap: 2rem 3rem;
        grid-auto-flow: row;
      }
      
      .card1 {
        width: 100%;
        justify-self: center;
        align-self: center;
        grid-area: 1 / 1 / 2 / 2;
      }
      
      .card2 {
        width: 100%;
        justify-self: center;
        align-self: center;
        grid-area: 1 / 2 / 2 / 3;
      }
      
      .card3 {
        width: 100%;
        justify-self: center;
        align-self: center;
        grid-area: 2 / 1 / 3 / 2;
      }
      
      .card4 {
        width: 100%;

        justify-self: center;
        align-self: center;
        grid-area: 2 / 2 / 3 / 3;
      }      
    }


      
      .component {
        margin: 4rem 2rem;
      }

      /*
      @keyframes slides {
        from {
          transform: translateX(0);
        }
        to {
          transform: translateX(-100%);
        }
      }
        */
      @keyframes slides {
        0% {
          transform: translateX(0);
        }
        100% {
          /* 200 */
          transform: translateX(calc(-296px * 10));
        }
      }
         
      .logos {
        display: none;
      }
      
     
      @media(min-width: 768px) {

        .logos {
          display: block;
          overflow: hidden;
          padding: 30px 0px;
          white-space: nowrap;
          position: relative;
          width: 91vw;
        }
  
        .logos, .logo_items {
          overflow: hidden;
        }
  
        .logo_items {
          width: calc(200px * 20);
        }
  
        .logo_items div {
          width: 200px;
        }        
      
      .logos:before, .logos:after {
        position: absolute;
        top: 0;
        content: '';
        width: 250px;
        height: 100%;
        z-index: 2;
      }
      
      .logos:before {
        left: 0;
        background: linear-gradient(to left, rgba(255,255,255,0), rgb(255, 255, 255));
      }
      
      .logos:after {
        right: 0;
        background: linear-gradient(to right, rgba(255,255,255,0), rgb(255, 255, 255));
      }
    }
           

    @media(min-width: 1200px) {

      .logos {
        max-width: 1200px;
      }

      .component {
        max-width: 1200px;
        margin: 6rem auto;
      }
    }

      .logo_items {
        display: flex;
        animation: 35s slides infinite linear;
      }

      .logo_items div {
        display: inline-block;
        margin: 0 3rem; 
        transition: all .2s ease-in-out;

        &:hover {
          transform: scale(1.2);

        }
      }
      
      .logos:hover .logo_items {
        animation-play-state: paused;       

      }
      
      .logo_items img{
        height: 100px;
      }

      p, a {
        font-size: 1.1rem;
      }      

  `
];
CampaignSectionRelationships = __decorate([
    customElement('campaign-section-relationships')
], CampaignSectionRelationships);
export { CampaignSectionRelationships };
//# sourceMappingURL=campaign-section-relationships.js.map